import React, { useEffect } from "react";
import {
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  IonContent,
  IonAvatar,
} from "@ionic/react";
import { sideMenu } from "helpers/staticData";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { CHANGEDASHBOARDPROFILE } from "stores/reducers/dashboardReducers";
import "styles/pages/sideMenu.scss";
import UserAvatar from "./images/userAvatar";
import { camera } from "ionicons/icons";
import { Camera, CameraResultType } from "@capacitor/camera";
import {
  changeFoto,
  CHANGEUSERPROFILE,
  profile,
  selectUser,
} from "stores/reducers/userReducer";
import { useDispatch } from "react-redux";
import useHandleResponse from "hooks/useHandleResponse";
import { Capacitor } from "@capacitor/core";

function SideMenu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const setResponse = useHandleResponse();
  const getPlatform = Capacitor.getPlatform();
  // eslint-disable-next-line no-unused-vars
  const { url } = useRouteMatch();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfile = async () => {
    await dispatch(profile());
  };

  const submitChange = async () => {
    const photo = await Camera.pickImages({
      resultType: CameraResultType.Uri,
      allowEditing: true,
      quality: 100,
    });
    const response = await fetch(
      photo?.webPath ? photo.webPath : photo?.photos[0].webPath
    );
    const blob = await response.blob();
    const fileReader = new FileReader();
    fileReader.readAsDataURL(blob);
    fileReader.onloadend = async function () {
      const response = await dispatch(
        changeFoto({ file_gambar: fileReader.result })
      );
      if (response.error) {
        return setResponse(response.payload);
      }
      setResponse(response.payload);
      getProfile();
      await dispatch(
        CHANGEDASHBOARDPROFILE({
          foto: photo?.webPath ? photo.webPath : photo?.photos[0].webPath,
        })
      );
      await dispatch(
        CHANGEUSERPROFILE({
          foto: photo?.webPath ? photo.webPath : photo?.photos[0].webPath,
        })
      );
    };
  };

  return (
    <IonContent id="sideMenu" className="bgcard">
      <div
        id="headerlogo"
        className="pdv pdh1 olb"
        style={{ marginTop: getPlatform === "ios" && 32 }}
      >
        <div
          id="logo"
          // src="./assets/pictures/logolight.svg"
          // alt="Logo Ekrutes"
          style={{ height: "28px", width: "160px" }}
        />
      </div>
      <div className="profile">
        <IonAvatar>
          <UserAvatar src={user?.url_foto_profile} />
          <div onClick={() => submitChange()} className="camera">
            <IonIcon icon={camera} size="large"></IonIcon>
            <IonLabel>Ubah Foto</IonLabel>
          </div>
        </IonAvatar>
        <IonLabel>
          <h5>
            {user.nama_depan} {user.nama_belakang}
          </h5>
          <p className="bold">{user.label_kelas}</p>
        </IonLabel>
        {/* <IonButton size="small" fill="outline">Profil Saya</IonButton> */}
      </div>
      <IonList lines="none" className="mgh">
        {sideMenu?.map((item, index) => (
          <Link key={index} to={item.url} style={{ textDecoration: "none" }}>
            <IonItem
              style={{
                color: "rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)",
                "--color-hover":
                  "rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.7)",
                fontWeight: 500,
              }}
              mode="md"
              key={item.id}
              button
              className={`br mgv4 ${
                history?.location?.pathname.split("/")[1] ===
                  item.url.split("/")[1] && "active"
              }`}
            >
              <IonIcon
                className={`${
                  history?.location?.pathname.split("/")[1] ===
                    item.url.split("/")[1] && "active"
                }`}
                slot="start"
                icon={item.icon}
              ></IonIcon>
              <IonLabel
                className={`${
                  history?.location?.pathname.split("/")[1] ===
                    item.url.split("/")[1] && "active"
                }`}
              >
                {item.title}
              </IonLabel>
            </IonItem>
          </Link>
        ))}
      </IonList>
    </IonContent>
  );
}

export default SideMenu;
